import React, { useEffect } from 'react';
import CountUp from 'react-countup';

const About = () => {
  useEffect(() => {
          const link = document.createElement("link");
          link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
          link.rel = "stylesheet";
          link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
          document.head.appendChild(link);
      
          return () => {
            // Optional: Clean up when component unmounts
            document.getElementById("tailwind-mutualfund")?.remove();
          };
        }, []);
  return (
    <>
    
  {/* <!-- Hero Section --> */}
  <section className="bg-blue-50 py-20 text-center">
    <h1 className="text-4xl font-bold text-blue-900 mb-4">About Us</h1>
    <p className="text-lg text-gray-700 max-w-2xl mx-auto">Meet the passionate minds behind GPS Finvest — a team blending financial expertise with technological innovation to empower your investment journey.</p>
  </section>

  {/* <!-- Sliding Services Section --> */}
  <section className="py-10 bg-white text-center">
    <h2 className="text-2xl font-bold text-green-700 mb-6">Our Services</h2>
    <div className="scrolling-wrapper px-6">
      <div className="bg-green-50 rounded-lg shadow p-4">Mutual Funds</div>
      <div className="bg-green-50 rounded-lg shadow p-4">Loan Against Securities</div>
      <div className="bg-green-50 rounded-lg shadow p-4">Bonds</div>
      <div className="bg-green-50 rounded-lg shadow p-4">AIFs</div>
      <div className="bg-green-50 rounded-lg shadow p-4">Research Analyst</div>
      <div className="bg-green-50 rounded-lg shadow p-4">Global Market Access</div>
    </div>
  </section>

  {/* <!-- Core Team Section --> */}
  <section className="py-16 bg-blue-50 text-center">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-blue-900 mb-10">Our Leadership Team</h2>
      <div className="flex justify-center gap-6 text-left flex-nowrap overflow-x-auto">      
      <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300 w-72">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">🧑‍💼 Madhusudan Toshniwal</h3>
          <p>Operating Partner</p>
          <p className="mt-2">A certified mutual fund distributor having cleared the NISM exam. Brings extensive leadership experience and strategic insight to GPS Finvest, with a focus on compliance, investor education, and distribution services in the financial markets.</p>
        </div>

        <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300 w-72">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">🧑‍💼 Gunjan Choksi</h3>
          <p>Managing Partner</p>
          <p className="mt-2">A seasoned finance professional with over 12 years of experience in stock broking and wealth management, having worked with reputed institutions like Monarch, Marwadi, and SBICAP Securities. SEBI Registered Investment Adviser (IA), Certified Financial Planner (CFP), and holds an MBA in Finance</p>
        </div>
       
        <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300 w-72">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">👩‍💻 Priyanka Soni</h3>
          <p>Technology Partner</p>
          <p className="mt-2">Director of Torbit Multisoft Pvt. Ltd., CA & techie leading the digital backbone of GPS Finvest's fintech services.</p>
        </div>
      </div>
    </div>
  </section>


  {/* <!-- Our Mission --> */}
  <section className="py-16 bg-white text-center">
    <div className="max-w-4xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-green-700 mb-6">Our Mission</h2>
      <p className="text-lg text-gray-700">At GPS Finvest, our mission is to make smart investing seamless and accessible for every Indian through technology, expertise, and personalized advisory.</p>
    </div>
  </section>

  
    </>
  );
};


export default About;
